import DOTA2 from './DOTA2';

export default DOTA2
